import { render, staticRenderFns } from "./DatabaseSearchIcon.vue?vue&type=template&id=70fca7bf&scoped=true&"
import script from "./DatabaseSearchIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DatabaseSearchIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fca7bf",
  null
  
)

export default component.exports